<script setup lang="ts">
import { SubtotalsBlockType } from '~/lib/services/store/catalog/cart.dtos'

withDefaults(
  defineProps<{
    subtotalBlock: SubtotalsBlockType
    freeShippingPromo?: boolean
  }>(),
  {
    freeShippingPromo: false,
  }
)

const { t } = useLocale()

const { format } = useFormatAmount()

const specialRowClass = (key: string) => {
  const rowClassArr = []
  if (['subtotal'].includes(key)) rowClassArr.push('font-bold !text-mcd-black')
  return rowClassArr.join(' ')
}
</script>

<template>
  <div class="flex flex-col gap-[14px]">
    <div
      v-for="[key, amount] in Object.entries(subtotalBlock)"
      :key="key"
      :data-test="`cart-amount-row--${key}`"
      class="flex flex-row items-center justify-between text-sm text-mcd-secondaryDarkGrey"
      :class="specialRowClass(key)"
    >
      <template v-if="key === 'shipping' && freeShippingPromo">
        <p>
          {{ t(`shoppingCart.${key}`) }}
        </p>
        <FreeShippingBubble />
      </template>
      <template v-else>
        <p>{{ t(`shoppingCart.${key}`) }}</p>
        <span class="block">{{ format(amount) }}</span>
      </template>
    </div>
  </div>
</template>
